import { css } from "lit";

export default css`
    .projectile {
        display: block;
        position: absolute;
        width: 40px;
        height: 40px;
        background-repeat: no-repeat;
        background-size: contain;
    }

    .enemyProjectile {
        background-image: url("assets/img/minigames/dragoninvaders/spells/fireball.png");
    }

    .playerProjectile {
        background-image: url("assets/img/minigames/dragoninvaders/spells/energy-ball.png");
    }
`;